import { createContext } from 'react'
const dic = {}
global.ctx = key => dic[key] ||= createContext()
